import { useState } from "react";
import { Ear, RefreshCw, Send, X } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";
import { RippBadge } from "./primitives";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KIND_TONE = { proof: "emerald", take: "cyan", meme: "amber", build: "cyan", launch: "red" };

export const VoicePreview = ({ disabled, onPosted }) => {
  const [d, setD] = useState(null);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(null);
  const gen = async () => {
    setBusy("draft");
    try { const r = await axios.post(`${API}/voice/preview`, {}); setD(r.data); setText(r.data.text); }
    catch (e) { toast(`Preview failed — ${e.response?.data?.detail || e.message}`); }
    setBusy(null);
  };
  const approve = async () => {
    setBusy("post");
    try {
      const r = await axios.post(`${API}/voice/approve`, { text, kind: d.kind });
      toast(r.data.ok ? `Posted (${r.data.kind}): ${r.data.text.slice(0, 80)}…` : `Not posted — ${r.data.error}`);
      if (r.data.ok) { setD(null); onPosted?.(); }
    } catch (e) { toast(`Post failed — ${e.response?.data?.detail || e.message}`); }
    setBusy(null);
  };
  if (!d) {
    return <button onClick={gen} disabled={disabled || !!busy} data-testid="voice-hear-first" className="flex items-center gap-1 rounded-sm border border-[var(--meme)] px-1.5 py-[2px] text-[8px] font-bold tracking-[0.14em] text-[var(--meme)] hover:bg-[var(--meme)]/10 disabled:opacity-40"><Ear size={10} /> {busy ? "DRAFTING…" : "HEAR IT FIRST"}</button>;
  }
  const over = text.length > 280;
  return (
    <div className="rounded-sm border border-[var(--meme)]/60 bg-black/30 p-1.5 space-y-1 font-mono" data-testid="voice-preview">
      <div className="flex items-center gap-1.5 text-[8px]">
        <RippBadge tone={KIND_TONE[d.kind] || "cyan"} testid="voice-preview-kind">{d.kind.toUpperCase()}</RippBadge>
        <RippBadge tone={d.source === "grokbot" ? "meme" : "muted"} testid="voice-preview-source">{d.source === "grokbot" ? "GROKBOT · EASTIE VOICE" : d.source.toUpperCase()}</RippBadge>
        <span className={`tabular-nums ${over ? "text-[var(--r2-red)]" : "text-[var(--r2-text2)]"}`} data-testid="voice-preview-chars">{text.length}/280</span>
        <button onClick={approve} disabled={!!busy || over || !text.trim()} data-testid="voice-preview-approve" className="ml-auto flex items-center gap-1 rounded-sm bg-[var(--meme)] px-2 py-[2px] text-[8px] font-black tracking-[0.14em] text-black disabled:opacity-40"><Send size={10} /> {busy === "post" ? "POSTING…" : "APPROVE & POST"}</button>
        <button onClick={gen} disabled={!!busy} data-testid="voice-preview-regenerate" className="flex items-center gap-1 rounded-sm border border-[var(--r2-border)] px-1.5 py-[2px] text-[8px] font-bold tracking-[0.14em] text-[var(--r2-text2)] hover:text-[var(--r2-text1)] disabled:opacity-40"><RefreshCw size={10} className={busy === "draft" ? "animate-spin" : ""} /> REGENERATE</button>
        <button onClick={() => setD(null)} disabled={!!busy} data-testid="voice-preview-discard" className="flex items-center gap-1 text-[8px] font-bold tracking-[0.14em] text-[var(--r2-text2)] hover:text-[var(--r2-red)]"><X size={10} /> DISCARD</button>
      </div>
      <textarea value={text} onChange={(e) => setText(e.target.value)} rows={2} data-testid="voice-preview-text" className="w-full resize-none rounded-sm border border-[var(--r2-border)] bg-transparent p-1.5 text-[10px] leading-snug text-[var(--r2-text1)] focus:border-[var(--meme)] focus:outline-none" />
    </div>
  );
};
